import Api from "./Api";
import { debugLog } from "../../utils/debug";

export async function fetchLatestPublicSongFlow() {
    return Api.get(`/public/song-flows/latest`)
        .then(res => res.data)
        .catch(() => null);
}

export async function fetchPublicSongFlow(slug) {
    return Api.get(`/public/song-flows/${slug}`)
        .then(res => res.data)
        .catch(error => {
            debugLog("Error fetching public song-flow:", error.message);
            return null;
        });
}

export async function subscribeToPublicSongFlowGeneral(email, name, recaptchaToken, honeypot) {
    return Api.post(`/public/song-flows/subscribe`, { email, name, recaptchaToken, honeypot })
        .then(res => res.data)
        .catch(error => {
            debugLog("Error subscribing to public song-flow:", error.message);
            return null;
        });
}

export async function subscribeToPublicSongFlow(slug, email, name, recaptchaToken, honeypot) {
    return Api.post(`/public/song-flows/${slug}/subscribe`, { email, name, recaptchaToken, honeypot })
        .then(res => res.data)
        .catch(error => {
            debugLog("Error subscribing to public song-flow:", error.message);
            return null;
        });
}

export async function unsubscribeFromPublicSongFlow(token) {
    return Api.get(`/public/song-flows/unsubscribe/${token}`)
        .then(res => res.data)
        .catch(error => {
            debugLog("Error unsubscribing from public song-flow:", error.message);
            return null;
        });
}

export async function adminListShareableSongFlows() {
    return Api.get(`/api/admin/curated-song-flows`)
        .then(res => res.data)
        .catch(error => {
            debugLog("Error listing shareable song-flows:", error.message);
            return null;
        });
}

export async function adminGetSongFlowDetail(playlistId) {
    return Api.get(`/api/admin/curated-song-flows/${playlistId}`)
        .then(res => res.data)
        .catch(error => {
            debugLog("Error fetching song-flow detail:", error.message);
            return null;
        });
}

export async function adminUpdateSongFlowPublishing(playlistId, shareableCuratedFlow, published) {
    return Api.put(`/api/admin/curated-song-flows/${playlistId}/publishing`, {
        shareableCuratedFlow,
        published
    })
        .then(res => res.data)
        .catch(error => {
            debugLog("Error updating song-flow publishing:", error.message);
            return null;
        });
}

export async function adminListRecipients(status) {
    const params = status ? `?status=${status}` : "";
    return Api.get(`/api/admin/curated-song-flows/recipients${params}`)
        .then(res => res.data)
        .catch(error => {
            debugLog("Error listing recipients:", error.message);
            return null;
        });
}

export async function adminSendSongFlow(playlistId, sendToAll, recipientIds) {
    return Api.post(`/api/admin/curated-song-flows/${playlistId}/send`, {
        sendToAll,
        recipientIds: recipientIds || []
    })
        .then(res => res.data)
        .catch(error => {
            debugLog("Error sending song-flow:", error.message);
            return null;
        });
}
